import { Link } from "react-router";

interface Props {
    fromPath: string;
    fromName: string;
}

export function PageNav({ fromPath, fromName }: Props) {
    return (
        <div className="flex gap-x-1">
            <Link to={fromPath}>
                <p className="text-sm">{fromName}</p>
            </Link>
            <p className="text-sm">{">"}</p>
            <p className="text-sm">{"informacion"}</p>
        </div>
    );
}